export default "__VITE_ASSET__BwLgxTW3avOjVbBj0C9ikQ__"